import { InjectionToken } from '@angular/core';
import { PaysafeConfig } from '../models/paysafe/paysafe-config.interface';

export const PAYSAFE_CONFIG = new InjectionToken<PaysafeConfig>(
  'Paysafe config'
);
